import React from 'react';
import { MessageCircleIcon, InstagramIcon, MailIcon, PhoneIcon } from 'lucide-react';
export function Footer() {
  const whatsappLink = 'https://wa.me/12817980349';
  return <footer className="bg-dark-900 border-t border-gold/30 pt-16 pb-8 px-4" data-id="element-11">
      <div className="max-w-7xl mx-auto" data-id="element-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 mb-12" data-id="element-13">
          {/* Brand Column */}
          <div className="md:col-span-5" data-id="element-14">
            <div className="flex items-center gap-3 mb-6" data-id="element-15">
              <img src="https://cdn.magicpatterns.com/uploads/tytkshGoctiAv8HZxiVooC/nano-banana-2_Ultra-realistic_extreme_close-up_of_a_luxury_emblem._The_design_from_the_referen-0.jpg" alt="Killshot Digital Venture Logo" className="h-12 w-12 object-cover rounded-full border border-gold/30" data-id="element-16" />
              <span className="font-serif text-gold tracking-widest text-lg font-semibold uppercase" data-id="element-17">
                Killshot Digital Venture
              </span>
            </div>
            <p className="font-sans text-gray-400 leading-relaxed mb-8 max-w-md" data-id="element-18">
              Agencia boutique especializada en infraestructura digital de alto
              rendimiento. Transformamos tu presencia online en una máquina de
              conversión premium.
            </p>
            <div className="flex gap-4" data-id="element-19">
              <a href="https://www.instagram.com/killshot.digital?igsh=b3V0MzF6Ym40OHl4" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-800 border border-gold/20 flex items-center justify-center text-gold hover:bg-gold hover:text-black transition-colors" data-id="element-20">
                <InstagramIcon className="w-5 h-5" data-id="element-21" />
              </a>
              <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-dark-800 border border-gold/20 flex items-center justify-center text-gold hover:bg-gold hover:text-black transition-colors" data-id="element-22">
                <MessageCircleIcon className="w-5 h-5" data-id="element-23" />
              </a>
            </div>
          </div>

          {/* Contact Column */}
          <div className="md:col-span-4" data-id="element-24">
            <h4 className="font-serif text-white text-xl mb-6" data-id="element-25">Contacto</h4>
            <ul className="space-y-4" data-id="element-26">
              <li data-id="element-27">
                <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors" data-id="element-28">
                  <PhoneIcon className="w-5 h-5 text-gold" data-id="element-29" />
                  <span data-id="element-30">+1 (281) 798-0349</span>
                </a>
              </li>
              <li data-id="element-31">
                <a href="mailto:info@killshotdigital.com" className="flex items-center gap-3 text-gray-400 hover:text-gold transition-colors" data-id="element-32">
                  <MailIcon className="w-5 h-5 text-gold" data-id="element-33" />
                  <span data-id="element-34">info@killshotdigital.com</span>
                </a>
              </li>
            </ul>
          </div>

          {/* CTA Column */}
          <div className="md:col-span-3 flex flex-col items-start md:items-end justify-center" data-id="element-35">
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 bg-gradient-to-r from-gold to-gold-dark text-black px-6 py-3 rounded-sm font-sans font-semibold hover:opacity-90 transition-opacity hover-gold-glow w-full sm:w-auto" data-id="element-36">
              <MessageCircleIcon className="w-5 h-5" data-id="element-37" />
              <span data-id="element-38">Hablemos por WhatsApp</span>
            </a>
          </div>
        </div>

        <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-39">
          <p className="text-gray-500 text-sm font-sans text-center md:text-left" data-id="element-40">
            © 2025 Killshot Digital Venture. Todos los derechos reservados.
          </p>
          <div className="flex gap-6 text-sm text-gray-500" data-id="element-41">
            <a href="#" className="hover:text-gold transition-colors" data-id="element-42">
              Privacidad
            </a>
            <a href="#" className="hover:text-gold transition-colors" data-id="element-43">
              Términos
            </a>
          </div>
        </div>
      </div>
    </footer>;
}